<template>
  <div class="lead-collector-section__form">
    <div
      v-if="collectorStep === 'infoForm'"
    >
      <div class="lead-collector-section__title">
        <z-title
          align="left"
          class="lead-collector-section__item-title"
          size="medium"
        >
          {{ $t('title') }}
        </z-title>
        <z-text
          align="left"
          class="lead-collector-section__subtitle"
          size="medium"
        >
          {{ $t('subtitle') }}
        </z-text>
      </div>
      <QForm
        class="lead-collector-form__info-form"
        @submit="submitLeadInfo"
      >
        <z-input-field
          label="Qual seu nome?"
          class="lead-collector-form__info-form-name"
        >
          <z-input
            v-model="leadName"
            class="lead-collector-name-input"
            size="medium"
            placeholder="Ex.: João Souza"
            type="text"
          />
        </z-input-field>

        <z-input-field
          v-slot="{ valid }"
          error-message="Por favor, informe seu e-mail"
          label="Qual seu e-mail?"
          rules="required|email"
          class="lead-collector-form__info-form-email"
        >
          <z-input
            v-model="leadEmail"
            class="lead-collector-email-input"
            :valid="valid"
            placeholder="Ex.: joao.souza@gmail.com"
            type="email"
          />
        </z-input-field>

        <div class="lead-collector-form__info-form-footer">
          <z-button
            class="lead-collector-form__info-form-button"
          >
            Continuar
          </z-button>
        </div>
      </QForm>
    </div>
    <div
      v-else
      class="lead-collector-form__success"
    >
      <LeadCollectorSuccess
        orientation="horizontal"
      />
    </div>
  </div>
</template>

<script>
import LeadCollectorSuccess from './lead-collector-success'
import messages from './i18n/lead-collector-section.json'
import QForm from '~/components/q-form'
import submitInterests from '~/assets/js/services/submit-interest-service'

export default {
  name: 'LeadCollectorForm',
  components: {
    LeadCollectorSuccess,
    QForm,
  },
  data () {
    return {
      collectorStep: 'infoForm',
      leadName: '',
      leadEmail: '',
    }
  },
  methods: {
    submitLeadInfo ({ valid }) {
      if (!valid) return

      this.submitAutoFilledInterests()
    },
    submitAutoFilledInterests () {
      this.collectorStep = 'success'

      this.submitInterests()
    },
    submitInterests () {
      submitInterests({
        leadName: this.leadName,
        leadOrigin: 'manual_do_enem',
        leadEmail: this.leadEmail,
        leadSubscriptionType: ['manual_do_enem'],
        gtm: this.$gtm,
      })

      this.$emit('submit-interest-form')

      this.collectorStep = 'success'
    },
  },
  i18n: {
    messages: {
      'pt-BR': messages,
    },
  },
}
</script>

<style lang="scss">
.lead-collector-form__title {
  margin-bottom: var(--unit-0400);
}

.lead-collector-form__info-form {
  column-gap: var(--unit-0800);
  display: grid;
  grid-row-gap: var(--unit-0200);
  grid-template:
    'text'
    'email'
    'footer'
    / auto;

  @media (min-width: $breakpoint-desktop) {
    grid-template:
      'name name name'
      'text email footer'
      / 1fr 1fr;
  }
}

.lead-collector-form__info-form-email {
  grid-area: email;
  margin-bottom: var(--unit-0000);
}

.lead-collector-form__info-form-name {
  grid-area: text;
  margin-bottom: var(--unit-0000);
}

.lead-collector-form__info-form-footer {
  align-items: center;
  display: grid;
  grid-area: footer;
  grid-template:
    'checkbox'
    'button'
    / auto;
  justify-content: space-between;
  margin-top: var(--unit-0600);

  @media (min-width: $breakpoint-desktop) {
    grid-template:
      'checkbox button'
      / auto auto;
  }
}

.lead-collector-form__info-form-button {
  margin-top: var(--unit-0200);

  @media (min-width: $breakpoint-desktop) {
    margin-top: var(--unit-0000);
  }
}

.lead-collector-section__title {
  margin-bottom: var(--unit-0400);
}

.lead-collector-section__item-title {
  margin-bottom: var(--unit-0100);
}

.lead-collector-section__form {
  margin-bottom: var(--unit-0400);
}

</style>
